var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmacySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16602 2.16602C1.16602 1.88987 1.38987 1.66602 1.66602 1.66602H10.9993C11.2755 1.66602 11.4993 1.88987 11.4993 2.16602V14.8327C11.4993 15.1088 11.2755 15.3327 10.9993 15.3327H1.66602C1.38987 15.3327 1.16602 15.1088 1.16602 14.8327V2.16602ZM2.16602 2.66602V14.3327H10.4993V2.66602H2.16602Z",
    fill: "#87928A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7.5C10.5 7.22386 10.7239 7 11 7H14.3333C14.6095 7 14.8333 7.22386 14.8333 7.5V14.8333C14.8333 15.1095 14.6095 15.3333 14.3333 15.3333H11C10.7239 15.3333 10.5 15.1095 10.5 14.8333C10.5 14.5572 10.7239 14.3333 11 14.3333H13.8333V8H11C10.7239 8 10.5 7.77614 10.5 7.5Z",
    fill: "#87928A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83398 7.5C3.83398 7.22386 4.05784 7 4.33398 7H8.33398C8.61013 7 8.83398 7.22386 8.83398 7.5C8.83398 7.77614 8.61013 8 8.33398 8H4.33398C4.05784 8 3.83398 7.77614 3.83398 7.5Z",
    fill: "#87928A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33398 5C6.61013 5 6.83398 5.22386 6.83398 5.5V9.5C6.83398 9.77614 6.61013 10 6.33398 10C6.05784 10 5.83398 9.77614 5.83398 9.5V5.5C5.83398 5.22386 6.05784 5 6.33398 5Z",
    fill: "#87928A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacySmall);
export default __webpack_public_path__ + "static/media/pharmacy-small.cc171f09677ac854381f57a662b807c8.svg";
export { ForwardRef as ReactComponent };